enum StepStatus {
  ACTIVE,
  COMPLETED,
  DISABLED,
}

export default StepStatus;
